/**
 * Imports
 */
import { Box, Text } from 'components';
import * as React from 'react';

/**
 * Types
 */
type DataRowProps = {
  label?: string;
  value?: string;
};

/**
 * Icon component
 */
const DataRow: React.FC<DataRowProps> = (props) => {
  return (
    <Box display="flex" flexDirection="column" mb="12px">
      <Box mb="4px">
        <Text size="ui2" bold>
          {props?.label}
        </Text>
      </Box>
      <Text size="ui2" color="ui">
        {props?.value}
      </Text>
    </Box>
  );
};

/**
 * Exports
 */
export { DataRow };
